import { r as registerInstance, c as createEvent, h } from './index-5faac9d7.js';
import { i as isEmpty_1 } from './isEmpty-ea893565.js';
import { o as omitBy_1, i as isNil_1 } from './omitBy-d2a59910.js';
import { c as EQdsButtonImportance, ab as PRIMARY_BUTTONS, ac as SECONDARY_BUTTONS } from './currency-49e0d692.js';
import './index-39f51a91.js';
import { b as getDownloadButtonIcon, g as getDownloadButtonLabel } from './utils-cdf9de4e.js';
import { c as findProductFeedMinimalPrice, d as applyPriceTemplate, w as weeePricesToTextArray } from './price-4641eae8.js';
import { a as format } from './index-67820103.js';
import './_nodeUtil-549406aa.js';
import './_commonjsHelpers-7db8bc26.js';
import './_baseIteratee-17179c5e.js';
import './_Stack-cf94d4e7.js';
import './_arrayLikeKeys-26c55d84.js';
import './isSymbol-8fefec05.js';
import './toString-568546f3.js';
import './_isIndex-3036d479.js';
import './_getAllKeys-5ba06622.js';
import './hasIn-833a7ad2.js';
import './_basePickBy-19dc1369.js';
import './keysIn-b6895676.js';
import './_getAllKeysIn-bc564289.js';
import './analytics-b3108572.js';
import './lodash-7f024380.js';
import './flatMap-db621f8c.js';
import './_baseFlatten-eecfdcde.js';
import './_baseFor-a28737de.js';

const ctaAreaSeContainerCss = ":host{display:block}@media screen and (min-width: 980px){:host{border-top:1px solid #e7e6e6}}";

const CtaAreaSeContainer = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.buyOnlineClick = createEvent(this, "buyOnlineClick", 7);
    this.notifyButtonDidClick = createEvent(this, "notifyButtonDidClick", 7);
    this.downloadButtonDidClick = createEvent(this, "downloadButtonDidClick", 7);
    this.addToCartButtonDidClick = createEvent(this, "addToCartButtonDidClick", 7);
    this.getProductFeedMinimalPriceText = () => {
      const product = this.getCurrentProductFeed();
      const price = findProductFeedMinimalPrice(product);
      const { countryLanguageCode, priceTemplate } = this.commerceConnectorSettings.options;
      if (!price || !countryLanguageCode || !priceTemplate) {
        return null;
      }
      const formattedPrice = format(price, { locale: countryLanguageCode });
      return applyPriceTemplate(formattedPrice, priceTemplate);
    };
    this.productId = undefined;
    this.commerceConnectorSettings = undefined;
    this.productsFeed = undefined;
    this.ctaData = undefined;
    this.addToMyProductsLabel = undefined;
    this.removeFromMyProductsLabel = undefined;
    this.compareLabel = undefined;
    this.downloadLabel = undefined;
    this.showBuyOnline = undefined;
    this.isStickyBar = undefined;
    this.materialPriceGroup = undefined;
    this.imageUrl = undefined;
    this.imageTitle = undefined;
    this.showCompare = undefined;
    this.showFavorites = false;
    this.showSkeleton = false;
    this.isInMyProductsList = false;
    this.softwareDocuments = undefined;
    this.addToCartButtonRendered = false;
  }
  getPriceTextContent() {
    return this.showPartnerPrice()
      ? this.getProductFeedMinimalPriceText()
      : this.getProductPriceText();
  }
  showPartnerPrice() {
    var _a, _b, _c;
    return ((_b = (_a = this.commerceConnectorSettings) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.enablePrice) && ((_c = this.productsFeed) === null || _c === void 0 ? void 0 : _c.length) > 0;
  }
  isPriceAvailable() {
    var _a, _b;
    return !!(((_a = this.ctaData) === null || _a === void 0 ? void 0 : _a.price) && ((_b = this.ctaData) === null || _b === void 0 ? void 0 : _b.currency));
  }
  getProductPriceText() {
    return this.isPriceAvailable() ? `${this.ctaData.price}&nbsp;${this.ctaData.currency}` : null;
  }
  getCurrentProductFeed() {
    var _a;
    return (_a = this.productsFeed) === null || _a === void 0 ? void 0 : _a.find((product) => (product === null || product === void 0 ? void 0 : product.ProductId) === this.productId);
  }
  hasTooltip() {
    var _a;
    return !this.showPartnerPrice() && !isEmpty_1((_a = this.ctaData) === null || _a === void 0 ? void 0 : _a.weeePrices);
  }
  renderWeeePrices() {
    if (!this.hasTooltip()) {
      return null;
    }
    return weeePricesToTextArray(this.ctaData.weeePrices).map((text) => h("div", { innerHTML: text }));
  }
  findButtonType(buttonTypes) {
    return buttonTypes.find((type) => { var _a, _b; return type in ((_b = (_a = this.ctaData) === null || _a === void 0 ? void 0 : _a.buttons) !== null && _b !== void 0 ? _b : {}); });
  }
  renderButtonFactory(type, isSticky) {
    var _a, _b;
    const button = (_b = (_a = this.ctaData) === null || _a === void 0 ? void 0 : _a.buttons) === null || _b === void 0 ? void 0 : _b[type];
    if (!button) {
      return null;
    }
    switch (type) {
      case "BUY_ONLINE_BUTTON_REGULAR":
      case "BUY_ONLINE_BUTTON_APC":
        return this.renderBuyOnlineButton();
      case "NOTIFY_ME_BUTTON":
        return this.renderNotifyMeButton(button);
      case "ADD_TO_CART_BUTTON":
        return this.renderAddToCartButton(button, isSticky);
      case "DOWNLOAD_BUTTON":
        return this.renderDownloadButton(button);
      default:
        return null;
    }
  }
  renderBuyOnlineButton() {
    var _a, _b, _c, _d;
    const regularButton = (_b = (_a = this.ctaData) === null || _a === void 0 ? void 0 : _a.buttons) === null || _b === void 0 ? void 0 : _b.BUY_ONLINE_BUTTON_REGULAR;
    const apcButton = (_d = (_c = this.ctaData) === null || _c === void 0 ? void 0 : _c.buttons) === null || _d === void 0 ? void 0 : _d.BUY_ONLINE_BUTTON_APC;
    const buttonProps = {};
    if (regularButton && this.showBuyOnline) {
      buttonProps.label = regularButton.labels.defaultLabel;
      buttonProps.onClick = () => this.buyOnlineClick.emit();
    }
    else if (apcButton === null || apcButton === void 0 ? void 0 : apcButton.link) {
      buttonProps.label = apcButton.labels.defaultLabel;
      buttonProps.icon = "arrow-top-right-on-square";
      buttonProps.onClick = () => this.buyOnlineClick.emit(apcButton.link);
    }
    return isEmpty_1(buttonProps) ? null : buttonProps;
  }
  renderAddToCartButton(button, isSticky) {
    this.addToCartButtonRendered = true;
    return {
      importance: EQdsButtonImportance.STANDARD,
      icon: "shopping-cart",
      label: button.labels.defaultLabel,
      onClick: (e) => {
        this.addToCartButtonDidClick.emit({ initialEvent: e, isStickyBar: isSticky });
      },
    };
  }
  renderNotifyMeButton(button) {
    return {
      label: button.labels.defaultLabel,
      onClick: () => this.notifyButtonDidClick.emit(button.link),
    };
  }
  renderDownloadButton(button) {
    return {
      icon: getDownloadButtonIcon(this.softwareDocuments),
      label: getDownloadButtonLabel(this.softwareDocuments, button, this.downloadLabel),
      onClick: () => this.downloadButtonDidClick.emit(),
    };
  }
  renderPrimaryButton(isSticky) {
    const buttonType = this.findButtonType(PRIMARY_BUTTONS);
    return this.renderButtonFactory(buttonType, isSticky);
  }
  renderSecondaryButton(isSticky) {
    const buttonType = this.findButtonType(SECONDARY_BUTTONS);
    return this.renderButtonFactory(buttonType, isSticky);
  }
  mapCtaButtons(isSticky = false) {
    return omitBy_1({
      emphasized: this.renderPrimaryButton(isSticky),
      standard: [this.renderSecondaryButton(isSticky)],
    }, isNil_1);
  }
  getPriceFromLabel() {
    var _a, _b;
    return this.showPartnerPrice() ? (_b = (_a = this.commerceConnectorSettings) === null || _a === void 0 ? void 0 : _a.labels) === null || _b === void 0 ? void 0 : _b.priceFrom : null;
  }
  isFavoritesAllowed() {
    return this.showFavorites && !this.addToCartButtonRendered;
  }
  renderStickyCtaArea() {
    return (h("pes-cta-area-view-sticky", { imageUrl: this.imageUrl, imageTitle: this.imageTitle, priceHTML: this.getPriceTextContent(), tooltipHTML: this.renderWeeePrices(), buttons: this.mapCtaButtons(true), priceFromLabel: this.getPriceFromLabel(), addToMyProductsLabel: this.addToMyProductsLabel, removeFromMyProductsLabel: this.removeFromMyProductsLabel, showFavorites: this.isFavoritesAllowed(), isInFavorites: this.isInMyProductsList }));
  }
  render() {
    var _a, _b, _c;
    if (this.isStickyBar) {
      return this.renderStickyCtaArea();
    }
    return (h("pes-cta-area-view", { productId: this.productId, priceHTML: this.getPriceTextContent(), tooltipHTML: this.renderWeeePrices(), buttons: this.mapCtaButtons(), showSkeleton: this.showSkeleton, materialPriceGroup: this.materialPriceGroup, priceFromLabel: this.getPriceFromLabel(), compareLabel: this.compareLabel, addedToCartLabel: (_c = (_b = (_a = this.ctaData) === null || _a === void 0 ? void 0 : _a.labels) === null || _b === void 0 ? void 0 : _b.addedToCart) !== null && _c !== void 0 ? _c : null, showAddedToCartLabel: this.addToCartButtonRendered && this.isInMyProductsList, isInFavorites: this.isInMyProductsList, showCompare: this.showCompare, addToMyProductsLabel: this.addToMyProductsLabel, removeFromMyProductsLabel: this.removeFromMyProductsLabel, showFavorites: this.isFavoritesAllowed() }));
  }
};
CtaAreaSeContainer.style = ctaAreaSeContainerCss;

export { CtaAreaSeContainer as pes_cta_area_se_container };
